export default __webpack_public_path__ + "static/bg-20bc338f3d8f803b20872fd109e3fb5e.webp";